import React from "react"
import { useQuery } from "@apollo/react-hooks"
import { Spinner } from "components/spinner"
import ShoppingCartItems from "./ShoppingCartItems"

import { GET_ORDERDETAILS } from "../gql"

const ShoppingCartFinish = ({ shoppingCartId, renderDeliverySection }) => {
  const { data, loading } = useQuery(GET_ORDERDETAILS, {
    fetchPolicy: "cache-and-network",
    variables: {
      id: shoppingCartId
    }
  })

  if (loading || !data) {
    return <Spinner />
  }

  return (
    <>
      <div
        className="order-finish text-center mt-5 mb-3"
        style={{
          display: "flex",
          justifyContent: " center",
          alignItems: " center"
        }}
      >
        <i
          className="far fa-thumbs-up"
          style={{
            color: "rgb(87, 176, 187)",
            fontSize: "60px",
            marginRight: "15px"
          }}
        ></i>
        <p className="mb-0" style={{ color: "rgb(126, 126, 126)" }}>
          訂單提交完成
        </p>
      </div>

      <div
        className="operational-block"
        style={{ width: "75%", margin: "0 auto" }}
      >
        <ShoppingCartItems
          orderDetails={data?.order?.orderDetails}
          justPreview
        />
      </div>
      {renderDeliverySection}
    </>
  )
}

export default ShoppingCartFinish
